import { render } from "./search-input.vue?vue&type=template&id=b78fcbe4&ts=true"
import script from "./search-input.vue?vue&type=script&lang=ts"
export * from "./search-input.vue?vue&type=script&lang=ts"

import "./search-input.vue?vue&type=style&index=0&id=b78fcbe4&lang=css"

import exportComponent from "C:\\Users\\claus\\source\\repos\\Joni\\SelfService\\JoniSelfService\\JoniSelfServicePortalUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__